/*
 * GearMustHave sticky affiliate CTA bar.
 * - Reveals the bar (CSS class .is-visible) only while the real in-page Amazon button is scrolled
 *   out of view (IntersectionObserver on the .gmh-amazon-link inside #ProductInfo-{sectionId}).
 * - The bar's button is itself a real <a> to the same Amazon URL (with the same gmh-amazon-link
 *   class + data-event-value), so no click-proxy logic is needed and the delegated Bing UET
 *   handler in theme.liquid fires amazon_click from it. Falls back to always-visible if the
 *   in-page button can't be found (better a persistent CTA than none).
 */
if (!customElements.get('gmh-sticky-atc')) {
  customElements.define(
    'gmh-sticky-atc',
    class GmhStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        var info = this.sectionId && document.getElementById('ProductInfo-' + this.sectionId);
        var target = info && info.querySelector('.gmh-amazon-link');

        if (target && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.classList.toggle('is-visible', !entry.isIntersecting);
              });
            },
            { threshold: 0 }
          );
          this.observer.observe(target);
        } else {
          // No in-page button to track — keep the CTA available rather than hidden.
          this.classList.add('is-visible');
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
